export default [
  {
    path: "/estados",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "estados_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Cidades", to: "estados_list" }],
          permission: "estado:view"
        }
      }
    ]
  }
];
